(() => {
  const SELECTORS = {
    section: '[data-ll-faqs]',
    category: '[data-ll-faqs-category]',
    trigger: '[data-ll-faq-trigger]',
    panel: '[data-ll-faq-panel]',
  };

  const closeItem = (trigger, panel) => {
    if (!trigger || !panel) return;

    trigger.setAttribute('aria-expanded', 'false');

    if (panel.hidden) return;

    panel.style.height = `${panel.scrollHeight}px`;
    panel.offsetHeight;
    panel.style.height = '0px';

    window.setTimeout(() => {
      if (trigger.getAttribute('aria-expanded') === 'false') {
        panel.hidden = true;
        panel.style.height = '';
      }
    }, 220);
  };

  const openItem = (trigger, panel) => {
    if (!trigger || !panel) return;

    panel.hidden = false;
    panel.style.height = '0px';
    trigger.setAttribute('aria-expanded', 'true');
    panel.offsetHeight;
    panel.style.height = `${panel.scrollHeight}px`;

    window.setTimeout(() => {
      if (trigger.getAttribute('aria-expanded') === 'true') {
        panel.style.height = '';
      }
    }, 220);
  };

  const syncDefaultOpenPanels = (scope = document) => {
    scope.querySelectorAll(SELECTORS.trigger).forEach((trigger) => {
      const panel = document.getElementById(trigger.getAttribute('aria-controls'));
      if (!panel) return;

      if (trigger.getAttribute('aria-expanded') === 'true') {
        panel.hidden = false;
      } else {
        panel.hidden = true;
      }
    });
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(SELECTORS.trigger);
    if (!trigger) return;

    const section = trigger.closest(SELECTORS.section);
    const panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!section || !panel) return;

    const shouldOpen = trigger.getAttribute('aria-expanded') !== 'true';

    if (shouldOpen && section.dataset.accordionMode === 'single') {
      section.querySelectorAll(`${SELECTORS.trigger}[aria-expanded="true"]`).forEach((openTrigger) => {
        if (openTrigger === trigger) return;

        const openPanel = document.getElementById(openTrigger.getAttribute('aria-controls'));
        closeItem(openTrigger, openPanel);
      });
    }

    if (shouldOpen) {
      openItem(trigger, panel);
    } else {
      closeItem(trigger, panel);
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    syncDefaultOpenPanels(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncDefaultOpenPanels());
  } else {
    syncDefaultOpenPanels();
  }
})();
